export const AUDIO_FILES_GET_NO_RECORDS = "No records found";
export const AUDIO_FILES_GET_ERROR =
  "There was an issue with fetching your files from our servers. Try again in a few minutes";
export const ADD_AUDIO_FILE = "Add Audio File";
export const GREETINGS_AND_MUSIC = "Greetings & Music on Hold";
export const GREETINGS_INITAL_PAGE = 1;
// null can't be used due to compatibility with MenuItems value attribute
export const DONT_FILTER_AUDIO_TYPE_VALUE = "All";